/*
 * @Description: ratings
 * @Author: 山淑兰
 * @Date: 2019-12-25 11:21:23
 * @LastEditTime : 2019-12-25 17:18:43
 * @LastEditors  : 山淑兰
 */
import Mock, { Random } from "mockjs";

Mock.mock("/v1/icon", "get", (res: any, req: any) => {
  const data = [];
  const weight_data = [];

  for (let i = 0; i < 1000; i++) {
    data.push({
      id: i,
      time: Random.date("yyyy-MM-dd hh:mm"),
      active: Random.float(1, 20, 4, 4),
    });
    weight_data.push({
      id: i,
      time: Random.date("yyyy-MM-dd hh:mm"),
      active: Random.float(1, 20, 4, 4),
    });
  }
  return {
    code: 200,
    message: "成功",
    data: {
      weight_data,
      data,
    },
  };
});
Mock.mock("/v1/weight", "get", (res: any, req: any) => {
  const data = [];

  for (let i = 0; i < 10; i++) {
    data.push({
      id: i,
      title: Random.ctitle(4),
      channel_name: Random.csentence(5),
      channel_code: Random.natural(1, 100),
      target_weight: Random.float(1, 5, 4, 4),
      start_time: Random.date("yyyy-MM-dd hh:mm"),
      end_time: Random.date("yyyy-MM-dd hh:mm"),
      target_time: Random.date("yyyy-MM-dd hh:mm"),
      target_pannel: Random.pick(["all", "35c", "52c"]),
      weight_status: Random.pick([-1, 0, 1]), // -1 等待 0 完成 1 加权
      current_weight: Random.float(1, 5, 4, 4),
    });
  }
  return {
    code: 200,
    message: "成功",
    data,
  };
});
